const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Presentation Inner Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Presentations} Analyze the resource defined to manage Presentations
 * @argument {Assignments} Analyze the resource defined to manage Assignments
 * @argument {Workflows} Analyze the resource defined to manage Workflows
 */
app.directive('presentationInnerViewer', ['Application', 'Authorization', 'Analyze', 'Presentations', 'ContentAuth', '$translate', '$location', function (Application, Authorization, Analyze, Presentations, ContentAuth, $translate, $location) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../templates/directives/presentation-inner-viewer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.hideTopbar = 0;
      self.darkBackground = 0;
      self.presentation = {};
      self.supportsFullscreenApi = document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
      self.user = Authorization.getAuthToken().user;
      self.routeParameters = Application.navigation.getRouteParameters();
      self.url = Application.navigation.getUrl();
      self.contentId = $scope.contentId || self.routeParameters.id || null;
      self.tracking = new Application.Tracking(Analyze, moment, 'presentation');

      self.navigation = {
        allSlides: [],
        surrogates: [],
        currentPage: 0,
        totalPages: 0,
        pageToIndex: {},
        init: function() {
          // fill array of active slides to same length as data.slides
          // Provide relevent data while iterating anyways
          var previousLastPage = -1;
          this.allSlides.forEach(function(slide, idx) {
            var navigation = self.navigation;
            var item = {
              position: '',
              active: false,
              properties: {
                fullscreen: true,
                index: idx,
                totalPages: 0
              },
            };
            item.type = slide.type;
            if (slide.type === 'youtube' || slide.type === 'vimeo' ) {
              slide.content = slide.properties.filter(function (obj) {return obj.name === 'source_id'})[0].value;
            }
            item.content = slide.content;

            // set total pages property of files
            if (slide.type === 'file') {
              item.properties.goNext = false;
              item.properties.goPrev = false;
              item.properties.goPage = false;
              item.properties.firstPage = 1;
              item.properties.totalPages = null;
              if (slide.properties[0].name === 'totalPages') {
                item.properties.totalPages = ~~slide.properties[0].value;
              } else {
                for (var j = 0; j < item.properties.length; j++) {
                  if (item.properties[j].name === 'totalPages') {
                    item.properties.totalPages = ~~slide.properties[j].value;
                    break;
                  }
                }
              }
              item.properties.totalPages = item.properties.totalPages || 0;
            }

            // Set the page to  index map for tracking true position
            item.properties.firstPage = previousLastPage + 1;
            if (item.properties.totalPages) {
              for (var k = 0; k < item.properties.totalPages; k++) {
                navigation.pageToIndex[previousLastPage + 1] = item.properties.index;
                previousLastPage = previousLastPage + 1;
              }
            } else {
              navigation.pageToIndex[previousLastPage + 1] = item.properties.index;
              previousLastPage = previousLastPage + 1;
            }
            navigation.totalPages = previousLastPage;
            navigation.surrogates.push(item);
          });

          if (this.currentPage > this.totalPages || this.currentPage < 0) {
            this.currentPage = 0;
          }
          this.goToPage(this.currentPage);
        },
        multiRequestHold: null,
        previousPageRequest: null,
        requestChange: function(direction) {
          var newPage = direction === 'next' ? 1 : direction === 'prev' ? -1 : 0;
          var holdTime = 400;

          // Direction is required
          if (direction === 0) {
            console.log('direction must be either "prev" or "next"');
            return;
          }

          // If no active requests, go to page and mock a request hold
          if (!this.multiRequestHold) {

            if (this.currentPage + newPage > this.totalPages || this.currentPage + newPage < 0) {
              return;
            }

            this.previousPageRequest = this.currentPage + newPage;
            this.goToPage(this.currentPage + newPage);
            this.multiRequestHold = setTimeout(function() {
              self.navigation.multiRequestHold = null;
              self.navigation.previousPageRequest = null;
            }, holdTime);

          // If there is an active request, reset the request hold to the new page value
          } else if (this.multiRequestHold) {

            if (this.previousPageRequest + newPage > this.totalPages || this.previousPageRequest + newPage < 0) {
              return;
            }

            window.clearTimeout(this.multiRequestHold);
            this.previousPageRequest = this.previousPageRequest + newPage;
            $location.search('slide', (this.previousPageRequest));
            this.multiRequestHold = setTimeout(function() {
              if (self.navigation.currentPage !== self.navigation.previousPageRequest){
                self.navigation.goToPage(self.navigation.previousPageRequest, direction);
              }
              self.navigation.multiRequestHold = null;
              self.navigation.previousPageRequest = null;
              $scope.$apply()
            }, holdTime);
          }

          // pause any video playback - always perform.. even when debounced
          $scope.$broadcast('pausevideo', {youtube: true});
        },
        goToPage: function(page) {
          var previousPage = this.currentPage;
          var direction = page - previousPage;
          function setPage(page, direction, internalFile) {

            if (!internalFile) {
              if (direction !== 1 && direction !== -1) {
                self.navigation.updateActiveBulk(page);
              } else {
                if (direction === 1 && self.navigation.surrogates[self.navigation.pageToIndex[page - 1]]) {
                  self.navigation.surrogates[self.navigation.pageToIndex[page - 1]].position = 'prev';
                }
                if (direction === -1 && self.navigation.surrogates[self.navigation.pageToIndex[page + 1]]) {
                  self.navigation.surrogates[self.navigation.pageToIndex[page + 1]].position = 'next';
                }
                self.navigation.updateActiveSingle(self.navigation.pageToIndex[page], direction);
                self.navigation.surrogates[self.navigation.pageToIndex[page]].position = '';
              }
            }

            $location.search('slide', (page));
            self.navigation.currentPage = page;
            self.tracking.checkFurthest(page / self.navigation.totalPages * 100);
          };


          // Page doesn't exist
          if ((!this.pageToIndex[page] && this.pageToIndex[page] !== 0) || !this.surrogates[this.pageToIndex[page]]) {
            // do something
            return;
          }
          // first page on load
          if (page === previousPage) {
            setPage(page, direction);
            if (this.surrogates[this.pageToIndex[page]].type === 'file') {
              self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.goPage = (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) > 1 ? (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) : 1;
            }
            return;
          }
          // if coming from same file
          if (this.pageToIndex[page] === this.pageToIndex[previousPage]) {
            if (direction === 1) {
              this.surrogates[this.pageToIndex[page]].properties.goNext = true;
              setPage(page, direction, true);
              return;
            }
            if (direction === -1) {
              this.surrogates[this.pageToIndex[page]].properties.goPrev = true;
              setPage(page, direction, true);
              return;
            }
            if (direction > 1 || direction < -1) {
              this.surrogates[this.pageToIndex[page]].properties.goPage = (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) > 1 ? (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) : 1;
              setPage(page, direction, true);
              return;
            }

          }
          // previous into new file
          if (direction < 0 && this.surrogates[this.pageToIndex[page]].type === 'file') {
            setPage(page, direction);
            this.surrogates[this.pageToIndex[page]].properties.goPage = (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) > 1 ? (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) : 1;
            return;
          }
          // next into new file
          if (direction > 0 && this.surrogates[this.pageToIndex[page]].type === 'file') {
            setPage(page, direction);
            this.surrogates[this.pageToIndex[page]].properties.goPage = (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) > 1 ? (page - self.navigation.surrogates[self.navigation.pageToIndex[page]].properties.firstPage + 1) : 1;
            return;
          }

          setPage(page, direction);
        },
        updateActiveSingle: function(index, direction) {
          if (direction === 1) {
            // no change in active 5 based on going next
            if (index < 3 || index > self.navigation.surrogates.length - 3) {
              return;
            }

            // should always be true, but a double check
            if (self.navigation.surrogates[index - 3]) {
              self.navigation.surrogates[index - 3].active = false;
            }
            // likewise
            if (self.navigation.surrogates[index + 2]) {
              self.navigation.surrogates[index + 2].active = true;
            }
          }
          // The reverse of the previous block
          if (direction === -1) {
            // no change in active 5 based on going previous
            if (index < 2 || index > self.navigation.surrogates.length - 4) {
              return;
            }

            // should always be true, but a double check
            if (self.navigation.surrogates[index - 2]) {
              self.navigation.surrogates[index - 2].active = true;
            }
            // likewise
            if (self.navigation.surrogates[index + 3]) {
              self.navigation.surrogates[index + 3].active = false;
            }
          }
        },
        updateActiveBulk: function(page) {
          var item;
          // set initial five active slides
          var start = 0;
          var end = 0;
          // if on first three slides
          if (this.pageToIndex[page] <= 2) {
            // load first five slides
            end = 5 > this.surrogates.length ? this.surrogates.length : 5;
          // if on last three slides
          } else if (this.pageToIndex[page] >= (this.surrogates.length - 3)) {
            // load last five slides
            start = this.surrogates.length - 5 < 0 ? 0 : this.surrogates.length - 5;
            end = this.surrogates.length;
          } else {
            //load two slides prior and two slides after current slide
            start = this.pageToIndex[page] - 2 > -1 ? this.pageToIndex[page] - 2 : 0;
            end = this.pageToIndex[page] + 3 > this.surrogates.length ? this.surrogates.length : this.pageToIndex[page] + 3;
          }

          for (var i = 0; i < this.surrogates.length; i++) {
            item = this.surrogates[i];
            if (i >= start && i < end) {
              item.active = true;
            } else {
              item.active = false;
            }

            if (i < this.pageToIndex[page]) {
              item.position = 'prev';
              continue;
            }
            if (i > this.pageToIndex[page]) {
              item.position = 'next';
              continue;
            }
            if (i === this.pageToIndex[page]) {
              item.position = '';
              continue;
            }
          }
        }
      };

      //basic keyboard handling
      self.onKeyUp = function(event) {

        if (event.keyCode > 36 && event.keyCode < 41) {

          if (event.keyCode == 37) {
            self.navigation.requestChange('prev');
          }
          else if(event.keyCode == 39) {
            self.navigation.requestChange('next');
          }
          else if (event.keyCode == 38) {
            self.hideTopbar = 1;
          }
          else if (event.keyCode == 40) {
            self.hideTopbar = 0;
          }
          $scope.$apply();

        }

      };

      self.toggleFullscreen = function(brexit) {

        //if fullscreen API supported
        if (self.supportsFullscreenApi) {

          //if page is already fullscreen
          if (brexit || document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement ) {

            document.exitFullscreen && document.exitFullscreen();
            document.webkitExitFullscreen && document.webkitExitFullscreen();
            document.mozCancelFullScreen && document.mozCancelFullScreen();
            document.msExitFullscreen && document.msExitFullscreen();
          } 
          else {

            document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
            document.documentElement.webkitRequestFullscreen && document.documentElement.webkitRequestFullscreen();
            document.documentElement.mozRequestFullScreen && document.documentElement.mozRequestFullScreen();
            document.documentElement.msRequestFullscreen && document.documentElement.msRequestFullscreen();

            //hide topbar when entering fullscreen
            self.hideTopbar = 1;
          }

        }

      };

      //set isFullscreen to true/false on fullscreen change event (to support mouse & keyboard input)
      self.initFullscreenWatch = function () {

        function handleFullscreenChange () {

          self.isFullscreen = (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) ? 1 : 0; 
          $scope.$apply();
        }

        if (self.supportsFullscreenApi) {

          document.exitFullscreen && document.addEventListener("fullscreenchange", handleFullscreenChange);
          document.webkitExitFullscreen && document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
          document.mozCancelFullScreen && document.addEventListener("mozfullscreenchange", handleFullscreenChange);
          document.msExitFullscreen && document.addEventListener("MSFullscreenChange", handleFullscreenChange);
        }
      }

      self.navigateAway = function () {

        //rm slide param and navigate to landing page
        $location.search('slide', null);
        Application.navigation.goTo( '/view/presentations/' + self.routeParameters.id);

        //(br)exit fullscreen
        self.toggleFullscreen(true);
      };

      //init
      self.initialize = function () {

        if (!self.contentId) {
          console.log('No id specified');
          Application.navigation.goToHome();
          return;
        }

        Presentations.get({
          subresource: self.contentId, 
          fields: 'title,description,author,slides,background_theme,end_copy,user,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,privacy_groups,private',
          'user-populate': 'first_name,last_name,email'
        }, function (data) {

          ContentAuth.allowView(data).then(function(allowed) {
            if(!allowed) {
              Application.messaging.addMessage({type: 'error', text: 'You don’t have permission to access this content, please contact your administrator if you believe this is a mistake', duration: 5});
              Application.navigation.goToHome();
              return;
            }
            Analyze.record({resource: 'views'}, {content: data._id, content_type: 'presentation'});
            Application.analyticsProvider.trackEvent('presentation_viewed');
            self.presentation = data;
            self.tracking.start(self.presentation);
            self.tracking.setInitialPosition(0);
            //order slides by ordinal
            var prop = 'ordinal';
            data.slides.sort(function(a, b) {
              if (a[prop] > b[prop]) {
                return 1;
              }
              if (a[prop] < b[prop]) {
                return -1;
              }
              return 0;
            });

            // set background theme and add intro slide
            self.darkBackground = data.background_theme === 'dark' ? 1 : 0;
            data.slides.unshift({type:'intro'}); 
            if (data.end_copy && data.end_copy !== '<p><br></p>' && data.end_copy !== '<p></p>' && data.end_copy !== '<h1><br></h1>' && data.end_copy !== '<h1></h1>') {
              data.slides.push({type: 'end', content: data.end_copy});
            }

            self.navigation.allSlides = data.slides;
            self.navigation.currentPage = self.routeParameters.slide ? ~~self.routeParameters.slide : 0;
            self.navigation.init();
            self.initFullscreenWatch();
          });
        }, function (error) {

          console.log('Error occured getting presentation ', self.contentId, error);
          Application.notifications.setError(self.translations['modules.notifications.unableToGetArticle']);
        });

        //add listeners
        window.addEventListener('keyup', self.onKeyUp, false);
        // listen for nav from slides
        $scope.$on('changeslide', function(event, data) {
          self.navigation.requestChange(data);
        });

      };

      $scope.$on('$destroy', function() {
        $location.search({});
        self.tracking.end();
      });

      $translate(['modules.notifications.unableToGetArticle']).then(function(translations){
        self.translations = translations;
        self.initialize();
      });

    }],
    controllerAs: 'viewInner'
  };
}]);
